__turbopack_context__.v({
  "body": "AgreementModal-module-scss-module__gmQyFa__body",
  "close_button": "AgreementModal-module-scss-module__gmQyFa__close_button",
  "head": "AgreementModal-module-scss-module__gmQyFa__head",
  "modal": "AgreementModal-module-scss-module__gmQyFa__modal",
  "overlay": "AgreementModal-module-scss-module__gmQyFa__overlay",
  "scroll_area": "AgreementModal-module-scss-module__gmQyFa__scroll_area",
  "title": "AgreementModal-module-scss-module__gmQyFa__title",
});
